import { Pipe, PipeTransform } from "@angular/core";
import { MomentService } from './../services/moment.service';

@Pipe({ name: 'asiDate' })
export class AsiDatePipe implements PipeTransform {

  constructor(private momentService: MomentService) {
  }

  transform(date: Date, format: string) {
    return this.momentService.format(date, format);
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/pipe/asi-date.pipe.ts